import React from "react";
import BirthdaySettingsComponent from "../../components/BirthdaySettings";

const BirthdaySettings = () => {
  return (
    <>
      <BirthdaySettingsComponent />
    </>
  );
};

export default BirthdaySettings;
